// export type ReportType = "occupied" | "decommissioned" | "false_information" | "comment";

import type { ReportType } from "../types/graphql/graphql";

export const reportTypeLabels = {
  OCCUPIED: "enums.report.types.Reports::Occupied",
  DECOMMISSIONED: "enums.report.types.Reports::Decommissioned",
  FALSE_INFORMATION: "enums.report.types.Reports::FalseInformation",
  COMMENT: "enums.report.types.Reports::Comment",
  NEW_ENTRY: "enums.report.types.Reports::NewEntry",
  RESERVATIONS_UNWANTED: "enums.report.types.Reports::ReservationsUnwanted",
} as const satisfies Record<ReportType, string>;
